/** Y-m-d date string for inquiry.dob (matches flatpickr dateFormat). */
export function formatInquiryDobDate(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) {
    return formatInquiryDobDate(new Date());
  }
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function defaultInquiryDob() {
  return formatInquiryDobDate(new Date());
}

/** Backend rejects null/empty dob; use today when not set. */
export function ensureInquiryDob(dob) {
  if (dob == null || (typeof dob === "string" && !dob.trim())) {
    return defaultInquiryDob();
  }
  const parsed = new Date(dob);
  if (Number.isNaN(parsed.getTime())) {
    return defaultInquiryDob();
  }
  return formatInquiryDobDate(parsed);
}
